
import XInput from 'vux/src/components/x-input/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
name: 'TradeState',
components: {
XInput,
Checker,
CheckerItem,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
Checklist,
Treeselect
},
data () {
return {
steps: [
{
label: '请选择年份',
slot: 'Years',
next: function (vue) {
if (vue.checked_year.length === 0) {
vue.$vux.alert.show({title: '注意', content: '请选择年份'})
return false
}
return true
}
},
{
label: '请选择商品名称/编号',
slot: 'CodesTS',
next: function (vue) {
if (vue.checked_codeTS.length === 0) {
vue.$vux.alert.show({title: '注意', content: '请选择商品名称/编号'})
return false
}
return true
}
},
{
label: '请选择国家/地区',
slot: 'Region',
next: function (vue) {
if (vue.checked_region.length === 0) {
vue.$vux.alert.show({title: '注意', content: '请选择国家/地区'})
return false
}
return true
}
},
{
label: '请选择进出口',
slot: 'IE',
next: function (vue) {
if (vue.checked_IE.length === 0) {
vue.$vux.alert.show({title: '注意', content: '请选择进出口'})
return false
}
return true
}
},
{
label: '请选择单位',
slot: 'Unit',
options: {
nextLabel: '查询',
pervLabel: '上一步'
},
next: function (vue) {
if (vue.checked_Unit.length === 0) {
vue.$vux.alert.show({title: '注意', content: '请选择单位'})
return false
}
vue.$router.push({ name: 'TradeStateChart',
params: {
Years: vue.checked_year,
CodeTS: vue.checked_codeTS,
Region: vue.checked_region,
IE: vue.checked_IE[0],
Unit: vue.checked_Unit[0]
}
})
}
}
],
years: [],
checked_year: [],
codeTS: null,
checked_codeTS: [],
region: null,
checked_region: [],
IE: ['进口数量', '出口数量', '进口金额', '出口金额', '进出口金额'],
checked_IE: ['进口数量'],
Unit: ['第一计量单位', '第二计量单位'],
checked_Unit: ['第一计量单位'],
normalizer (node) {
return {
id: node.Id + '$' + node.Name,
label: node.Name,
children: node.Children
}
}
}
},
methods: {
async loadCodeTSOptions ({ action, parentNode, callback }) {
if (parentNode) {
let children = (await this.$http.get('/API/TradeStat/CodeTSTree', {params: {parentId: parentNode.Id}})).data
children.map((item) => {
if (item.Leaf) {
delete item.Children
}
return item
})
parentNode.Children = children
} else {
this.codeTS = (await this.$http.get('/API/TradeStat/CodeTSTree')).data
}
},
async loadRegionOptions ({ action, parentNode, callback }) {
if (parentNode) {
let children = (await this.$http.get('/API/TradeStat/RegionTree', {params: {parentId: parentNode.Id}})).data
children.map((item) => {
if (item.Leaf) {
delete item.Children
}
return item
})
parentNode.Children = children
} else {
this.region = (await this.$http.get('/API/TradeStat/RegionTree')).data
}
},
selectAll (source) {
return source.map((item) => {
if (typeof item === 'object') {
return item.key
}
return item
})
},
revereSelect (source, dest) {
let r = source.filter(function (el) {
if (typeof el === 'object') {
return !dest.includes(el.key)
}
return !dest.includes(el)
})
return r.map((item) => {
if (typeof item === 'object') {
return item.key
}
return item
})
},
nextClicked (currentPage) {
if (this.steps[currentPage].next) {
return this.steps[currentPage].next(this)
}
return true
},
backClicked (currentPage) {
if (this.steps[currentPage].back) {
return this.steps[currentPage].back(this)
}
return true
}
},
async created () {
this.years = (await this.$http.get('/API/TradeStat/Years')).data
}
}



// WEBPACK FOOTER //
// ./src/components/TradeState.vue